import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { webformGet } from '@uncinc/react-drupal-core';

import { IMap, Submission } from '../types';
import WebformMapper from '../Mapper';

interface RiskSituationSubmissionProps {
  entity: IMap
}

const RiskSituationSubmission: React.FC<RiskSituationSubmissionProps> = ({ entity }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const webformId = entity.get('#risk_situation_webform_id') as string;
  const webform = useSelector<IMap>((state) => state.getIn(['webform', webformId, 'fields'])) as IMap;
  const submission = useSelector<IMap>((state) => state.getIn(['exerciseSubmissions', 'submissions', webformId])) as Submission;

  useEffect(() => {
    if (webformId && !webform) {
      // @ts-ignore
      dispatch(webformGet(webformId));
    }
  }, [dispatch, webformId, webform]);

  if (!webformId || !webform || !submission) {
    return null;
  }

  return (
    <div className="RiskSituationSubmission">
      <h2>{t('webform.components.risk_situation.title')}</h2>
      <div className="RiskSituationSubmission__questions">
        <WebformMapper
          entities={webform}
          exerciseSubmission={submission}
          hideLabels
        />
      </div>
    </div>
  );
};

export default RiskSituationSubmission;
